import { useCallback, useEffect, useState } from 'react';
import {
  type PushStatus,
  readPushStatus,
  subscribeToPush,
  unsubscribeFromPush,
} from './push-client.ts';

export function usePushStatus(): {
  status: PushStatus;
  loading: boolean;
  subscribe(): Promise<void>;
  unsubscribe(): Promise<void>;
  refresh(): Promise<void>;
} {
  const [status, setStatus] = useState<PushStatus>({
    state: 'unsupported',
    permission: 'unsupported',
    subscription: null,
  });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async (): Promise<void> => {
    setLoading(true);
    try {
      setStatus(await readPushStatus());
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    status,
    loading,
    refresh,
    subscribe: async () => {
      setLoading(true);
      try {
        setStatus(await subscribeToPush());
      } finally {
        setLoading(false);
      }
    },
    unsubscribe: async () => {
      setLoading(true);
      try {
        setStatus(await unsubscribeFromPush());
      } finally {
        setLoading(false);
      }
    },
  };
}
